import { render, staticRenderFns } from "./TwoFactorAuthenticationReset.vue?vue&type=template&id=5660fe96&scoped=true&"
import script from "./TwoFactorAuthenticationReset.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660fe96",
  null
  
)

export default component.exports